/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T08:26:51.026
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentHouseSalesPromotionItem,
	getRentHouseSalesPromotionItemCreateInit,
	getRentHouseSalesPromotionItemEditInit,
	getRentHouseSalesPromotionItemView,
	deleteRentHouseSalesPromotionItem
} from '@api/rentmanage/RentHouseSalesPromotionItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentHouseSalesPromotionItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesPromotionItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesPromotionItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesPromotionItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseSalesPromotionItem({}, RentHouseSalesPromotionItem) {
			return new Promise((resolve, reject) => {
				saveRentHouseSalesPromotionItem(RentHouseSalesPromotionItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesPromotionItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesPromotionItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseSalesPromotionItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseSalesPromotionItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
